import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import type { CompleteOnboardingRequest, OnboardingCompleteResponse } from "@/api/types";

export function useCompleteOnboarding() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data?: CompleteOnboardingRequest) =>
      api.post("onboarding/complete", { json: data ?? {} }).json<OnboardingCompleteResponse>(),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["onboarding-status"] });
      void queryClient.invalidateQueries({ queryKey: ["me"] });
      void queryClient.invalidateQueries({ queryKey: ["dashboard"] });
    },
  });
}
